import React, { Fragment, useState } from 'react'
import { wglcsApiService } from "../../services/WglcsApiService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons'

import "./refereshApi.style.css"

const RefereshApi = () => {
  const [apiEndpoints, setApiEndpoints] = useState([
    {
      pathname: "/transcript",
      apiEndpoints: [
        "/getenableusersbycompany",
        "/getwebsitesbyempCompany",
        "/getroleinterfaces"
      ]
    },
    {
      pathname: "/ip-block",
      apiEndpoints: [
        // "/getallblockedips",
        "/getwebsitesbyempCompany"
      ]
    },
    {
      pathname: "/report",
      apiEndpoints: [
        "/getwebsitesbyempCompany"
      ]
    },
    {
      pathname: "/canned",
      apiEndpoints: [
        "/getempcompanylanguagesdetail"
      ]
    },
    {
      pathname: "/pcanned",
      apiEndpoints: [
        "/getpercannedmessagesbyuserid_new"
      ]
    },
    {
      pathname: "/push_content",
      apiEndpoints: [
        "/getwebsitesbyempCompany"
      ]
    },
    {
      pathname: "/company",
      apiEndpoints: [
        "/GetEmployeeCompanyies",
        "/getemployeecompanyies",
        "/smtpinfo_selectall",
        "/getallcompaniesbyemployeecompanyid",
        "/getwebsitesbyempCompany",
        "/getclientpoc_bycompanyid"
      ]
    },
    {
      pathname: "/transcriptSubscribers",
      apiEndpoints: [
        //"/getallblockedips",
        "/departmentemailform_selectbyempcompanyid",
        "/getwebsitesbyempCompany"
      ]
    },
    {
      pathname: "/service-schedule",
      apiEndpoints: [
        "/getwebsitesbyempCompany",
        "/getempcompanylanguagesdetail"
      ]
    },
    {
      pathname: "/website-wise-resources",
      apiEndpoints: [
        "/getwebsitesbyempCompany",
        "/getusersbycompany"
      ]
    },
    {
      pathname: "/Assign-Users-to-Trainer",
      apiEndpoints: [
        "/getenableusersbycompany"
      ]
    },
    {
      pathname: "/PCMs-Approval",
      apiEndpoints: [
        "/getenableusersbycompany"
      ]
    },
    {
      pathname: "/Agent-PCM",
      apiEndpoints: [
        "/GetUsersByCompany",
        "/getusersbycompany"
      ]
    },
    {
      pathname: "/OneStepAccount",
      apiEndpoints: [
        "/getempcompanylanguagesdetail"
      ]
    },
    {
      pathname: "/smtpEmail",
      apiEndpoints: [
        "/getroleinterfaces",
        "/smtpinfo_selectall",
        "/getusersbycompany",
        "/usersmtpaddress_selectbyuserid",
      ]
    },
    {
      pathname: "/resourcesPool",
      apiEndpoints: [
        "/GetUsersByCompany",
        "/getusersbycompany",
        "/getwebsitesbyempCompany"
      ]
    },
    {
      pathname: "/resourcesPool/trained-on",
      apiEndpoints: [
        "/GetUsersByCompany",
        "/getusersbycompany",
        "/getwebsitesbyempCompany"
      ]
    },
    { // adding new secion from heres
      pathname: "/Chat-Logs",
      apiEndpoints: [
        "/getenableusersbycompany",
        "/getwebsitesbyempCompany"
      ]
    },
    {
      pathname: "/license-info",
      apiEndpoints: [
        "/getemployeecompanyies",
        "/licensedetails_selectbyempcompanyid"
      ]
    },
    {
      pathname: "/wrong-link-exceptions",
      apiEndpoints: [
        "/getwebsitesbyempCompany"
      ]
    },
    {
      pathname: "/Roles-Permission",
      apiEndpoints: [
        "/getemployeecompanyies"
      ]
    },
    {
      pathname: "/Company-Allowed-Interfaces",
      apiEndpoints: [
        "/getemployeecompanyies"
      ]
    },
    {
      pathname: "/Survey-Questions",
      apiEndpoints: [
        "/getwebsitesbyempCompany",
        "/getenableusersbycompany"
      ]
    },

    {
      pathname: "/Offline-Email-Exception",
      apiEndpoints: [
        "/getwebsitesbyempCompany"
      ]
    }, {
      pathname: "/employee-company",
      apiEndpoints: [
        "/getemployeecompanyies"]
    },
    {
      pathname: "/Offline-Email",
      apiEndpoints: [
        "/getwebsitesbyempCompany"
      ]
    },
    {
      pathname: "/View-All-Resources",
      apiEndpoints: []
    },
    {
      pathname: "/Dashboard-Reports",
      apiEndpoints: [
        "/getallcompaniesbyemployeecompanyid",
        "/GetAllReportingTimeZones",
        "/getwebsitebycomid",
        "/getwebsitesfordepvsdealermanaged",
        "/getlasoftwareonlyclients",
        "/getwebsitesbyempCompany"
      ]
    }
  ]);

  const refereshApi = () => {
    const currentPageUrl = new URL(window.location.href)
    const pageRoute = currentPageUrl.hash.replace("#", "")
    const found = apiEndpoints.find((item) => pageRoute?.includes(item.pathname))

    if (pageRoute === "/dashboard") {
      wglcsApiService.deleteApiCache()
      window.location.reload()
      return;
    }

    if (found) {
      found.apiEndpoints.map((endpoint) => {
        wglcsApiService.deleteApiFromCache(endpoint)
      })
      window.location.reload()
    } else {
    }
  }

  return (
    <Fragment>
      <span className="reload-icon" onClick={() => refereshApi()}>
        <FontAwesomeIcon
          icon={faArrowsRotate}
          title="Refresh Data"
        />
      </span>
    </Fragment>
  )
}

export default RefereshApi